export const cleanSlug = (slug: string) => {
  if (!slug) return;
  if (!slug.startsWith("/")) return slug;
  if (slug.startsWith("/")) slug = slug.substring(1); // remove first /
  return slug;
};
